<div class="pickup-address-contact" data-testid="pickup-address-contact-section">
  <div class="pickup-address-contact__heading">
    <puro-typography variant="h5-semibold" component="h3" class="pickup-address-contact__title">
      {{ 'createShipment.serviceStep.pickupDropOff.locationInstructionsTitle' | translate }}
    </puro-typography>

    @if (hasAddress()) {
      <div class="pickup-address-contact__summary">
        @if (address()!.streetLine) {
          <p class="pickup-address-contact__line">{{ address()!.streetLine }}</p>
        }
        @if (address()!.name) {
          <p class="pickup-address-contact__line">{{ address()!.name }}</p>
        }
        @if (address()!.phone) {
          <p class="pickup-address-contact__line">
            {{ 'createShipment.serviceStep.pickupDropOff.phoneLabel' | translate }}
            {{ address()!.phone }}
          </p>
        }
        @if (address()!.buzzer) {
          <p class="pickup-address-contact__line">
            {{ 'createShipment.serviceStep.pickupDropOff.buzzerLabel' | translate }}
            {{ address()!.buzzer }}
          </p>
        }
      </div>
    }
  </div>

  @if (showSchedulingFields()) {
    @if (locationsLoading()) {
      <output class="pickup-address-contact__status">
        {{ 'createShipment.serviceStep.pickupDropOff.locationsLoading' | translate }}
      </output>
    } @else if (locationsError()) {
      <puro-alert severity="error">{{ locationsError() }}</puro-alert>
    }

    <div class="pickup-address-contact__fields">
      <div class="pickup-address-contact__field">
        <app-floating-select
          [label]="'createShipment.serviceStep.pickupDropOff.pickupLocationLabel' | translate"
          [options]="locationOptions()"
          [fullWidth]="true"
          [required]="true"
          [ngModel]="locationCode()"
          (ngModelChange)="onLocationChange($event)"
          data-testid="pickup-location-select"
        />
      </div>

      <div class="pickup-address-contact__field pickup-address-contact__field--instructions">
        <puro-input
          [label]="'createShipment.serviceStep.pickupDropOff.instructionsPlaceholder' | translate"
          [ngModel]="courierInstructions()"
          (ngModelChange)="onInstructionsChange($event)"
          [maxLength]="maxInstructionsLength"
          [error]="hasCourierInstructionsEmojiError()"
          [errorMessage]="
            hasCourierInstructionsEmojiError()
              ? ('createShipment.validation.restrictedCharactersField'
                | translate
                  : {
                      fieldName:
                        ('createShipment.serviceStep.pickupDropOff.instructionsPlaceholder'
                        | translate),
                    })
              : ''
          "
          [endAdornment]="true"
          data-testid="pickup-courier-instructions"
        >
          <span endAdornment class="pickup-address-contact__tooltip-icon">
            <span class="visually-hidden" id="pickup-instructions-tooltip-desc">{{
              'createShipment.serviceStep.pickupDropOff.instructionsTooltip' | translate
            }}</span>
            <puro-tooltip
              #instructionsTooltip
              [content]="'createShipment.serviceStep.pickupDropOff.instructionsTooltip' | translate"
            >
              <button
                type="button"
                class="pickup-address-contact__tooltip-trigger"
                [attr.aria-label]="
                  'createShipment.serviceStep.pickupDropOff.instructionsTooltipAria' | translate
                "
                aria-describedby="pickup-instructions-tooltip-desc"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                (focus)="instructionsTooltip.show()"
                (blur)="instructionsTooltip.hide()"
              >
                <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
              </button>
            </puro-tooltip>
          </span>
        </puro-input>
      </div>
    </div>
  }
</div>
